/**
 * Status płatności
 *
 * @export
 * @enum {number}
 */
export enum PaymentState {
  CANCELED = 'CANCELED',
  FAILURE = 'FAILURE',
  NOT_ATTACHED = 'NOT_ATTACHED',
  SUCCESS = 'SUCCESS'
}

/**
 * Kolory na liście odpowiadające statusom
 *
 * @export
 * @enum {number}
 */
export enum PaymentStateColors {
  CANCELED = 'table-secondary',
  FAILURE = 'table-danger',
  NOT_ATTACHED = 'table-warning',
  SUCCESS = 'table-success'
}
